import { render, staticRenderFns } from "./addBooth.vue?vue&type=template&id=0dd1365c&scoped=true&"
import script from "./addBooth.vue?vue&type=script&lang=js&"
export * from "./addBooth.vue?vue&type=script&lang=js&"
import style0 from "./addBooth.vue?vue&type=style&index=0&id=0dd1365c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd1365c",
  null
  
)

export default component.exports